import axios, { isAxiosError } from 'axios'
import { getActiveRouter } from '@/router/runtime'
import { recordError, sendSessionReplay } from '@/services/tracking-sessions'

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    "lang" : "ar_001"
  }
})

instance.interceptors.response.use(
  (response) => {
    if (response?.data?.error?.code == 100) {
      if (typeof window !== 'undefined') {
        localStorage.clear()
      }

      // if (router.currentRoute.value.name != 'login') {

      //   router.push({ name: 'login' })
      // }
      // window.location.href = '/login'
    }

    return response
  },
  async (error) => {
    if (isAxiosError(error)) {
      if (error.response?.status == 500) {
        recordError({
          message: error.response?.data?.error?.message,
          stack: error.stack,
          name: error.response?.data?.error?.name,
          timestamp: new Date().toISOString(),
          data: error.response?.data?.error?.data,
          ...(error.response?.data?.error?.data &&
          typeof error.response?.data?.error?.data === 'object'
            ? error.response?.data?.error?.data
            : {})
        })

        await sendSessionReplay()
      }
    }

    if (isAxiosError(error) && error.response?.data?.error?.code == 100) {
      if (typeof window !== 'undefined') {
        localStorage.clear()
      }
      // router.push({ name: 'home' })

      if (typeof window !== 'undefined' && getActiveRouter()?.currentRoute.value.name !== 'login') {
        window.location.href = '/login'
      }
    }

    return Promise.reject(error)
  }
)

export default instance

/*

{
	"error": {
		"code": 100,
		"message": "Odoo Session Expired",
		"data": {
			"name": "odoo.http.SessionExpiredException",
			"debug": "Traceback (most recent call last):\n  File \"/usr/lib/python3/dist-packages/odoo/http.py\", line 624, in _handle_exception\n    return super(JsonRequest, self)._handle_exception(exception)\n  File \"/usr/lib/python3/dist-packages/odoo/http.py\", line 310, in _handle_exception\n    raise pycompat.reraise(type(exception), exception, sys.exc_info()[2])\n  File \"/usr/lib/python3/dist-packages/odoo/tools/pycompat.py\", line 14, in reraise\n    raise value\n  File \"/usr/lib/python3/dist-packages/odoo/addons/http_routing/models/ir_http.py\", line 460, in _dispatch\n    cls._authenticate(func.routing['auth'])\n  File \"/usr/lib/python3/dist-packages/odoo/addons/base/models/ir_http.py\", line 124, in _authenticate\n    getattr(cls, \"_auth_method_%s\" % auth_method)()\n  File \"/usr/lib/python3/dist-packages/odoo/addons/base/models/ir_http.py\", line 97, in _auth_method_user\n    raise http.SessionExpiredException(\"Session expired\")\nodoo.http.SessionExpiredException: Session expired\n",
			"message": "Session expired",
			"arguments": [
				"Session expired"
			],
			"exception_type": "internal_error",
			"context": {}
		}
	}
}
  
*/
